// extracted by mini-css-extract-plugin
export default {"row":"JSONModal_row__yVgz8","rowItemLarge":"JSONModal_rowItemLarge__vZf5d"};